import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {ConnectedRouter} from 'connected-react-router/immutable'
import { connect } from 'react-redux';
import Navbar from '../../components/NavBar';
import VersionNotification from '../../components/VersionNotification';
import routes from '../../routes'
import {Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement} from "chart.js";
import 'bootstrap/dist/css/bootstrap.css'
import 'semantic-ui-css/semantic.css'
import '../../style/css/style.css';

ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

class App extends Component {
    render () {
        const { history } = this.props;
      return (
        <React.Fragment>
          <VersionNotification />
          <Navbar />
          <ConnectedRouter history={history}>{ routes }</ConnectedRouter>
        </React.Fragment>
      );
    }
}
App.propTypes = {
    history: PropTypes.object,
    user: PropTypes.object
};

export default connect(state => ({
    user: state.get('auth').get('user')
}))(App);
